@if (advertisedDeployable !== undefined) {
  <div class="wm-deployable-group-container" [ngClass]="{'wm-grid': viewType === 'GRID', 'wm-list': viewType !== 'GRID', 'wm-deployable-group-container-available' : available, 'selected' : deploymentDialogVisible}" attr.data-testing-id="deployable-group-{{advertisedDeployable.displayName | dataTestingId}}">
    @if (viewType === 'LIST') {
      <div>
        <div class="wm-deployable-group"  [ngClass]="{'wm-deployable-group-available' : available, 'wm-deployable-group-unavailable' : !available, 'selected' : deploymentDialogVisible}" (click)="toggleDeploymentWindow()">
          <div class="wm-m-deployment-leftcolumn">
            <div class="deployable-logo-container">
              @if (hasAnnotations(deployableGroup.deployables[0])) {
                <div class="maintenance-info" [ngClass]="getAnnotationStatus(deployableGroup.deployables[0])">
                  <fa-icon icon="exclamation-triangle" [size]="'lg'" [pTooltip]="getAnnotationString(deployableGroup.deployables[0])"></fa-icon>
                </div>
              }
              @if (hasUserAnnotations(deployableGroup.deployables[0])) {
                <div class="user-annotations">
                  <fa-icon icon="info-circle" [size]="'lg'" [pTooltip]="getUserAnnotationString(deployableGroup.deployables[0])"></fa-icon>
                </div>
              }
              <img [src]="advertisedDeployable.logo" class="wm-m-deployable-logo" [pTooltip]="advertisedDeployable.displayName">
            </div>
            <div class="wm-m-deployable-name">
              @if (manufacturer != undefined) {
                <div class="wm-m-deployable-manufacturer-name">{{manufacturer}}<br/></div>
              }
              {{advertisedDeployable.displayName}}
            </div>
          </div>
          @if (subselectedDeployable.modelName !== undefined) {
            <div class="wm-deployable-group-platform-logo">
              @if (advertisedDeployable.platformLogo !== undefined) {
                <img [src]="advertisedDeployable.platformLogo"/>
              }
              <div class="wm-deployable-group-platform-version"> {{subselectedDeployable.platform.platformVersion}}</div>
            </div>
          }
          @if (browsers !== undefined && (!deploymentDialogVisible || deployableGroup.deployables.length === 1)) {
            <wm-browsers-info [browsers]="browsers"></wm-browsers-info>
          }
        </div>
        @if (deploymentDialogVisible && !requestInProgress) {
          <div class="wm-deployable-group-subselection">
            <div class="wm-deployable-group-subselection-container">
              @if (deployableGroup.deployables.length > 1) {
                <div>
                  @for (item of deployableGroup.deployables; track item; let i = $index) {
                    <div (click)="selectDeployable(item)" [ngClass]="{'selected': item.id === subselectedDeployable.id, 'disabled': !isDeployableAvailable(subselectedDeployable)}"  class="wm-deployable-group-subselection-item deployable">
                      @if (getLocale(item) !== undefined) {
                        <span>Locale: {{getLocale(item)}}</span>
                      }
                      <wm-browsers-info [browsers]="item.browser"></wm-browsers-info>
                    </div>
                  }
                </div>
              }
              <div class="wm-deployable-group-subselection-item">
                <input type="text" placeholder="Name for new device" [(ngModel)]="desiredName" pInputText class="p-inputtext-sm wm-deployable-group-subselection-control"/>
                @if (supportsResolution) {
                  <p-select [options]="availableResolutions" [(ngModel)]="desiredResolution" class="wm-deployable-group-subselection-control"></p-select>
                }
                <p-checkbox [binary]="true" [(ngModel)]="allowJobs"></p-checkbox>
                <div>
                  Allow automation
                </div>
                <p-button (click)="requestDeploymentOfTemplate(true)" [disabled]="!isDeployableAvailable(subselectedDeployable)" severity="secondary" label="Deploy and Open" attr.data-testing-id="deployable-group-{{advertisedDeployable.displayName | dataTestingId}}-deployandopenbtn"></p-button>
                <p-button (click)="requestDeploymentOfTemplate(false)" [disabled]="!isDeployableAvailable(subselectedDeployable)" label="Deploy" attr.data-testing-id="deployable-group-{{advertisedDeployable.displayName | dataTestingId}}-deploybtn"></p-button>
              </div>
            </div>
          </div>
        }
        @if (deploymentDialogVisible && requestInProgress) {
          <div class="wm-deployable-group-subselection">
            <div class="wm-deployable-group-deployprogress">
              <span>Initiating&nbsp;deployment...</span>
              <p-progressBar mode="indeterminate"></p-progressBar>
        </div>
          </div>Ï
        }
      </div>
    }
    <!-- TODO: this currently relies on the assumption that there's only one deployable in each group, so it can only be used for OpenSTF devices -->
    @if (viewType === 'GRID') {
      <div>
        <div class="wm-grid-deployable-summary" [ngClass]="{'selected': deploymentDialogVisible, 'unavailable': !isDeployableAvailable(subselectedDeployable)}" (click)="toggleDeploymentWindow()">
          <div class="wm-grid-deployable-left-column">
            <img [src]="advertisedDeployable.logo" class="wm-grid-deployable-logo">
          </div>
          <div class="wm-grid-deployable-right-column">
            <div class="wm-grid-deployable-info">
              @if (manufacturer != undefined) {
                <div class="wm-m-deployable-manufacturer-name">{{manufacturer}}<br/></div>
              }
              <div class="wm-grid-deployable-name" [title]="advertisedDeployable.displayName">{{advertisedDeployable.displayName}}</div>
              @if (advertisedDeployable.platformLogo !== undefined) {
                <div class="wm-grid-platform-logo"><img [src]="advertisedDeployable.platformLogo"/></div>
              }
              <div class="wm-grid-deployable-platform-version">{{subselectedDeployable.platform.platformVersion}}</div>
            </div>
            @if (isDeployableAvailable(subselectedDeployable)) {
              <div class="wm-grid-deployable-browsers wm-grid-deployable-right-column-lower" [ngClass]="{'hidden': deploymentDialogVisible}">
                <wm-browsers-info [multiline]="true" [browsers]="subselectedBrowsersToDisplay"></wm-browsers-info>
              </div>
            }
            @if (!isDeployableAvailable(subselectedDeployable)) {
              <div class="wm-grid-deployable-status wm-grid-deployable-right-column-lower">not available</div>
            }
            <div class="wm-grid-deployable-deployment-dialog wm-grid-deployable-right-column-lower" [ngClass]="{'hidden': !deploymentDialogVisible}">
              @if (requestInProgress) {
                <div class="wm-grid-deployable-deployment-dialog-content">
                  <div class="wm-grid-deployable-deployment-spinner"><p-progressSpinner [style]="{'width': '50px', 'height': '50px'}"></p-progressSpinner></div>
                </div>
              }
              @if (!requestInProgress) {
                <div class="wm-grid-deployable-deployment-dialog-content">
                  <input type="text" placeholder="Name" [(ngModel)]="desiredName" pInputText class="p-inputtext-sm wm-grid-deployable-deployment-dialog-name"/>
                  <p-split-button class="wm-grid-deployable-deployment-dialog-button" (onClick)="requestDeploymentOfTemplate(false)" [disabled]="!isDeployableAvailable(subselectedDeployable)" label="Deploy" appendTo="body" [model]="deployButtonModel" attr.data-testing-id="deployable-group-{{advertisedDeployable.displayName | dataTestingId}}-deploybtn"></p-split-button>
                </div>
              }
            </div>
          </div>
          @if (deployed !== 0) {
            <div class="wm-grid-template-currently-deployed">{{deployed}} currently deployed in this project</div>
          }
        </div>
      </div>
    }
  </div>
}
